var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWilsonelectronicsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 771.9 166.6",
    style: {
      enableBackground: "new 0 0 771.9 166.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#0088CF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M210.7,136.2h22.9v5.9h-16.3v6.2h14.3v5.9h-14.3v6.4h16.5v5.9h-23.1V136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M263.7,136.2h6.7v24.3h15.1v6.1h-21.8V136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314.4,136.2h22.9v5.9h-16.3v6.2h14.3v5.9h-14.3v6.4h16.5v5.9h-23.1V136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M366.1,151.5L366.1,151.5c0-8.7,6.5-15.8,15.8-15.8c5.7,0,9.2,1.9,12,4.7l-4.3,4.9c-2.3-2.1-4.7-3.4-7.8-3.4 c-5.1,0-8.8,4.3-8.8,9.5v0.1c0,5.2,3.6,9.5,8.8,9.5c3.5,0,5.6-1.4,8-3.6l4.3,4.3c-3.1,3.3-6.6,5.4-12.5,5.4 C372.7,167.1,366.1,160.2,366.1,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.4,142.4h-9.2v-6.2h25.2v6.2h-9.2v24.2h-6.7V142.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M475.3,136.2h13.9c3.9,0,6.9,1.1,8.9,3.1c1.7,1.7,2.6,4.1,2.6,6.9v0.1c0,4.9-2.6,8-6.5,9.4l7.4,10.9h-7.8 l-6.5-9.7h-0.1H482v9.7h-6.7V136.2z M488.8,151c3.3,0,5.1-1.7,5.1-4.3v-0.1c0-2.9-2-4.3-5.3-4.3H482v8.7H488.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M529.2,151.5L529.2,151.5c0-8.7,6.8-15.8,16.2-15.8c9.4,0,16.1,7,16.1,15.6v0.1c0,8.6-6.8,15.7-16.2,15.7 C535.9,167.1,529.2,160.1,529.2,151.5z M554.5,151.5L554.5,151.5c0-5.3-3.8-9.6-9.2-9.6c-5.4,0-9.1,4.3-9.1,9.5v0.1 c0,5.2,3.8,9.5,9.2,9.5C550.8,161,554.5,156.7,554.5,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M591.3,136.2h6.2l14.2,18.7v-18.7h6.6v30.4h-5.7l-14.7-19.3v19.3h-6.6V136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M649.8,136.2h6.7v30.4h-6.7V136.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M686.6,151.5L686.6,151.5c0-8.7,6.5-15.8,15.8-15.8c5.7,0,9.2,1.9,12,4.7l-4.3,4.9c-2.3-2.1-4.7-3.4-7.8-3.4 c-5.1,0-8.8,4.3-8.8,9.5v0.1c0,5.2,3.6,9.5,8.8,9.5c3.5,0,5.6-1.4,8-3.6l4.3,4.3c-3.1,3.3-6.6,5.4-12.5,5.4 C693.3,167.1,686.6,160.2,686.6,151.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M741.8,162.2l4-4.7c2.7,2.3,5.6,3.7,9.1,3.7c2.7,0,4.4-1.1,4.4-2.9v-0.1c0-1.7-1-2.6-6.1-3.9 c-6.1-1.6-10.1-3.3-10.1-9.3v-0.1c0-5.5,4.4-9.2,10.6-9.2c4.4,0,8.2,1.4,11.3,3.9l-3.5,5c-2.7-1.9-5.3-3-7.9-3s-3.9,1.2-3.9,2.6 v0.1c0,2,1.3,2.6,6.6,4c6.2,1.6,9.6,3.8,9.6,9.1v0.1c0,6-4.6,9.4-11.2,9.4C750.1,167,745.4,165.4,741.8,162.2z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "CMYK_231_",
    className: "st1",
    points: "165.9,99.4 138.1,71.6 94.4,115.3 87.2,115.8 87.2,108.1 130.9,64.3 103.3,36.8  59.6,80.5 52.3,80.8 52.3,73.2 96,29.5 68.2,1.7 1.1,68.8 1.1,68.8 1.1,68.8 1.1,117.7 49.9,117.7 49.9,166.5 98.8,166.5  98.8,166.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.9,1.4h23.4l20.5,67.1L243,1.1h18.7l22.2,67.4l20.5-67.1h22.8l-33.8,99.8h-19L252,36.4l-22.4,64.8h-19 L176.9,1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M341.9,1.4h21.8v99.1h-21.8V1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M387,1.4h21.8v79.3h37.9v19.8H387V1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M460.5,86.1l12.9-15.4c8.9,7.4,18.3,12,29.6,12c8.9,0,14.3-3.5,14.3-9.3V73c0-5.5-3.4-8.4-20-12.6 c-20-5.1-32.8-10.6-32.8-30.3v-0.3c0-18,14.4-29.9,34.7-29.9c14.4,0,26.8,4.5,36.8,12.6L524.6,29c-8.8-6.1-17.4-9.8-25.8-9.8 c-8.4,0-12.7,3.8-12.7,8.6v0.3c0,6.5,4.2,8.6,21.4,13c20.1,5.2,31.4,12.5,31.4,29.7v0.3c0,19.7-15,30.7-36.4,30.7 C487.5,101.9,472.3,96.7,460.5,86.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M553.1,51.2V51c0-28.2,22.2-51.2,52.8-51.2c30.6,0,52.5,22.8,52.5,51V51c0,28.2-22.2,51.2-52.8,51.2 C575.1,102.2,553.1,79.4,553.1,51.2z M635.6,51.2V51c0-17-12.5-31.1-30-31.1s-29.7,13.9-29.7,30.9V51c0,17,12.5,31.1,30,31.1 C623.5,82.1,635.6,68.2,635.6,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M675.4,1.4h20.1l46.4,61v-61h21.5v99.1h-18.5l-48-63v63h-21.5V1.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWilsonelectronicsLogo);
export default __webpack_public_path__ + "static/media/wilsonelectronics-logo.530d826b3b548e0e33f4e4c335ede8a0.svg";
export { ForwardRef as ReactComponent };